import Api from './Api'

export default {
    get(keyword, pageNumber, sort, category, categoryId) {
        let url = `posts?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}&category=${category}`;
        if (categoryId) url += `&categoryId=${categoryId}`;
        return Api().get(url);
    },
    getOne(slug) {
        return Api().get(`posts/${slug}`);
    }
}